import React, { Component } from 'react';
import equal from 'deep-equal';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { FlatButton, SelectField, MenuItem, Popover } from 'material-ui';
import { translate } from 'admin-on-rest';
import { formValueSelector, change as onChange } from 'redux-form';

const styles = {
  layoutRow: {
    display: 'flex',
    flexFlow: 'row',
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
    paddingTop: '10px',
    // position: 'absolute',
    top: '10px',
    right: '0',
    zIndex: 1,
  },
  popover: {
    width: 'auto',
    padding: '0.9em',
    display: 'flex',
    alignItems: 'center',
  },
};

export class CloneAssortment extends Component {
  constructor() {
    super();
    this.state = {
      visible: false,
    };
  }

  shouldComponentUpdate = (nextProps, nextState) => (!equal(this.props, nextProps) || !equal(this.state, nextState));

  toggle = () => this.setState({ visible: !this.state.visible });

  change = (e, index, value, choices) => {
    this.setState({ venueId: value, venue: choices.find((venue) => venue._id === value) });
  }

  render() {
    // eslint-disable-next-line no-shadow
    const { choices, change, translate, marketValue, hidden } = this.props;
    const { visible, venueId, venue } = this.state;

    if (!marketValue) return null;

    return (
      <div style={styles.layoutRow} ref={(wrapper) => { this.anchorEl = wrapper; }}>
        {!hidden && <FlatButton label={visible ? translate('close') : translate('clone')} onClick={() => this.toggle()} />}
        <Popover
          open={visible}
          anchorEl={this.anchorEl}
          anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
          targetOrigin={{ horizontal: 'right', vertical: 'top' }}
          onRequestClose={(e) => this.toggle(e)}
        >
          <div style={styles.popover}>
            <SelectField
              floatingLabelText="Venue"
              value={venueId}
              onChange={(e, index, value) => this.change(e, index, value, choices)}
            >
              {choices.length > 0 && choices.map((v) => (
                <MenuItem key={v._id} value={v._id} primaryText={v.name} />
              ))}
            </SelectField>
            {venue && venue._id &&
              <FlatButton
                label={translate('clone')}
                onClick={() => {
                  change('record-form', 'products', venue.products);
                  change('record-form', 'market', venue.market);
                  this.toggle({});
                }}
              />
            }
          </div>
        </Popover>
      </div>
    );
  }
}

const enhance = compose(
  translate
);

const selector = formValueSelector('record-form');

export default connect((state) => ({ marketValue: selector(state, 'market') }), { change: onChange })(enhance(CloneAssortment));
